import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  chats: [],
  currentBot: '',
};

const aiActionsSlice = createSlice({
  name: 'aiActions',
  initialState,
  reducers: {
    updateChats: (state, action) => {
      const botId = state.currentBot

      const chatIndex = state.chats.findIndex((chat) => chat?.botId === botId);

      if (chatIndex >= 0) {
        state.chats[chatIndex] = { botId, chats: action.payload };
      } else {
        state.chats.push({ botId, chats: action.payload });
      }
    },
    updateCurrentBot: (state, action) => {
      state.currentBot = action.payload;
    },
  },
});

export const { updateChats, updateCurrentBot } = aiActionsSlice.actions;

export default aiActionsSlice.reducer;
